export default __webpack_public_path__ + "static/media/defaultSpaceman.169adee0.png";